import { PAGE_SIZE } from "./consts";

import type { NetworkPayload } from "../../../composites";

const BULK_REVERSAL_DETAILS_STATE_NOT_IN =
  "failed,bulk_reversal_canceled,expired,rejected_approval,approval_expired";

export const API = {
  fetchBulkPayments: (
    offsetIndex: number,
    pageSize = PAGE_SIZE,
    queryString?: string,
    ordering?: string,
    disableCaching?: boolean,
  ) => {
    const defaultQueryString =
      "&exclude_completed_one_time=true&state_not_in=schedule_rejected,rejected_approval,approval_expired,expired";
    const orderingQuery = ordering
      ? `&ordering=${encodeURIComponent(ordering)}`
      : "";
    const formattedQueryString =
      (queryString ? `&${queryString}` : "") +
      defaultQueryString +
      orderingQuery;
    return {
      url: `bulk_payments?offset=${offsetIndex}&limit=${pageSize}${formattedQueryString}`,
      options: {
        method: "GET",
        disableCaching,
      },
    } satisfies NetworkPayload;
  },
  fetchBulkPaymentById: (uuid: API.BulkPaymentId | API.BulkReversalId) => {
    return {
      url: `bulk_payments/${uuid}/`,
      options: {
        method: "GET",
      },
    } satisfies NetworkPayload;
  },
  fetchBulkReversalsForBulkPayment: (bulkPaymentId: API.BulkPaymentId) => {
    return {
      url: `bulk_reversals?bulk_payment=${bulkPaymentId}&state_not_in=${BULK_REVERSAL_DETAILS_STATE_NOT_IN}`,
      options: {
        method: "GET",
      },
    } satisfies NetworkPayload;
  },
  createBulkPayment: (
    idempotencyKey: UUID,
    payload: API.CreateBulkPayment.Request,
  ): NetworkPayload => {
    return {
      url: "bulk_payments/",
      options: {
        method: "POST",
        payload,
        idempotencyKey,
      },
    };
  },
  deleteBulkPayment: (uuid: API.BulkPaymentId): NetworkPayload => {
    return {
      url: `bulk_payments/${uuid}/cancel`,
      options: {
        method: "PUT",
        payload: {},
      },
    };
  },
  approveBulkPayment: (uuid: API.BulkPaymentId) => {
    return {
      url: `bulk_payments/${uuid}/approve/`,
      options: {
        method: "POST",
        payload: {},
      },
    } satisfies NetworkPayload;
  },
  cancelBulkPayment: (uuid: API.BulkPaymentId) => {
    return {
      url: `bulk_payments/${uuid}/cancel/`,
      options: {
        method: "POST",
        payload: {},
      },
    } satisfies NetworkPayload;
  },
  createBulkReversal: (payload: API.CreateBulkReversal.Request) => {
    return {
      url: "bulk_reversals/",
      options: {
        method: "POST",
        payload,
      },
    } satisfies NetworkPayload;
  },
};
